import React from "react";
import { Button } from "antd";
import { NavLink } from "react-router-dom";
import BackButtonImage from "assets/Icon-Back-BTN.svg";
import "styles/MasterButton.scss";

export const BUTTON_TYPES = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  CLEAR: "CLEAR",
  ERROR: "ERROR",
};

export default function MasterButton({
  type,
  text,
  callback,
  disabled,
  loading,
  style,
  children,
  wide,
  small,
}) {
  let className;
  switch (type) {
    case BUTTON_TYPES.PRIMARY:
      className = "master-button--primary ";
      break;
    case BUTTON_TYPES.SECONDARY:
      className = "master-button--secondary ";
      break;
    case BUTTON_TYPES.TERTIARY:
      className = "master-button--tertiary ";
      break;
    case BUTTON_TYPES.ERROR:
      className = "master-button--error ";
      break;
    case BUTTON_TYPES.GHOST:
      className = "master-button--ghost ";
      break;
    case BUTTON_TYPES.CLEAR:
    default:
      className = "master-button--clear ";
  }
  return (
    <Button
      loading={loading}
      disabled={disabled || loading}
      className={
        "master-button " +
        className +
        (disabled ? "master-button--disabled " : " ") +
        (wide ? "master-button--wide " : " ") +
        (small ? "master-button--small" : "")
      }
      onClick={callback}
      style={style}
    >
      {text}
      {children}
    </Button>
  );
}

export function BackButton({ navlink, onClick }) {
  if (navlink) {
    return (
      <NavLink to={navlink} className="back-button" name={navlink}>
        <img src={BackButtonImage} alt="back button" width="24px" />
        <div className="margin-left">Back</div>
      </NavLink>
    );
  } else {
    return (
      <div onClick={onClick} className="back-button" name={navlink}>
        <img src={BackButtonImage} alt="back button" width="24px" />
        <div className="margin-left">Back</div>
      </div>
    );
  }
}

export const LinkButton = ({ text, link }) => {
  return (
    <NavLink to={link}>
      <div className="link-button">{text}</div>
    </NavLink>
  );
};
